import script from "./ElementShadow.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementShadow.vue?vue&type=script&lang=ts&setup=true"

import "./ElementShadow.vue?vue&type=style&index=0&id=3a267bbc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a267bbc"]])

export default __exports__